import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Director } from "../models/director"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";
import { DirectorEducationalQualification } from "../models/directoreducationalqualification";
import { DirectorProfessionalExperience } from "../models/directorprofessionalexperience";
import { DirectorFormsFiledAndIntimations } from "../models/directorformfiledandintimations";
import { DirectorOtherEnclosure } from "../models/directorotherenclosures";
@Injectable({
  providedIn: 'root'
})
export class DirectorService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'director/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllDirector(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Director>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllDirector?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewDirector(DirectorID?: string): Observable<Array<Director>> {
    return this.httpService.get(this.apiEndpoint + 'viewDirector/' + (DirectorID ? DirectorID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveDirector(directors: Director): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveDirector/', directors).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveQualification(qualifications: Array<DirectorEducationalQualification>): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveQualification/', qualifications).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  save_Professional(professionals: Array<DirectorProfessionalExperience>): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveProfessional/', professionals).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  save_Forms(forms:Array<DirectorFormsFiledAndIntimations>): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveForms/', forms).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  save_OtherEnclosure(otherenclosure:Array<DirectorOtherEnclosure>): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveOtherEnclosure/', otherenclosure).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }


  checkEmail(Emailid?: string, DirectorId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&DirectorId=' + (DirectorId ? DirectorId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteDirector(DirectorID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteDirector/' + (DirectorID ? DirectorID : '00000000-0000-0000-0000-000000000000'), DirectorID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(DirectorName?: string,Director_Id?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?DirectorName=' + (DirectorName ? DirectorName : '')+ '&Director_Id=' + (Director_Id ? Director_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
